module.exports = "<span (click)=\"clickExpandCollapse()\">\n    <ng-content></ng-content>\n</span>";